import React, { useState } from 'react';
import { Box, Typography, Chip, IconButton, Button } from '@mui/material';
import { Close } from '@mui/icons-material';
// Import all CSS modules in the same order as parent to ensure consistent webpack ordering
// eslint-disable-next-line no-unused-vars
import _complainStyles from '../complain.module.css';
// eslint-disable-next-line no-unused-vars
import _deleteModalStyles from './delete.module.css';
// eslint-disable-next-line no-unused-vars
import _statusChangeStyles from './statusChange.module.css';
import styles from './viewStudent.module.css';
// eslint-disable-next-line no-unused-vars
import _rejectComplaintStyles from './reject_complaint.module.css';
import { getStatusColor } from './data';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import StatusChange from './StatusChange';
import MarkAsResolvedModal from './MarkAsResolvedModal';
import { getStatusUnderReviewComplaintsColor } from '..';
import useDisableBodyScroll from '@/hooks/useDisableBodyScroll';
import OtpVerificationModal from './OtpVerificationModal';
// import { co } from '@fullcalendar/core/internal-common';

const ViewComplaint = ({ open, handleMarkAsReviewed, onClose, complaint, onConfirm, tabState, complaintManagementPermission }) => {
  // Prevent background scrolling when modal is open
  useDisableBodyScroll(open);
  const [statusChangeModalOpen, setStatusChangeModalOpen] = useState(false);
  const [markAsResolvedModalOpen, setMarkAsResolvedModalOpen] = useState(false);
  const [otpVerificationOpen, setOtpVerificationOpen] = useState(false);
  const [resolveOtpOpen, setResolveOtpOpen] = useState(false);

  console.log('ViewComplaint - statusChangeModalOpen:', statusChangeModalOpen);

  console.log('seleectview complain', complaint);

  if (!open || !complaint) return null;

  console.log('complaint in view', complaint);
  const complaintByName =
    complaint?.createdByUser?.name ||
    (typeof complaint?.createdByUser === 'string' ? complaint.createdByUser : '') ||
    complaint?.dept?.createdByUser ||
    complaint?.createdByName ||
    'Not Available (N/A)';
  const complaintByPhone =
    complaint?.createdByUser?.phoneNumber ||
    complaint?.createdByUser?.mobileNumber ||
    complaint?.dept?.phoneNumber ||
    complaint?.phoneNumber ||
    'Not Available (N/A)';
  const normalizedStatus = String(complaint?.status || '').toLowerCase();
  const handledByLabel = normalizedStatus === 'resolved' ? 'Resolved By' : normalizedStatus === 'rejected' ? 'Rejected By' : 'Handled By';

  const handleResolve = () => {
    console.log('Opening resolve modal');
    setMarkAsResolvedModalOpen(true);
  };

  const handleResolveComplaint = () => {
    setMarkAsResolvedModalOpen(false);
    onClose();
    onConfirm?.();
  };

  const handleStatusChangeConfirm = () => {
    // Close the status change modal first
    setStatusChangeModalOpen(false);
    // Then refresh the data
    onConfirm?.();
  };
  // function formatDateTime(isoString) {
  //   const date = new Date(isoString);

  //   return date.toLocaleString("en-IN", {
  //     day: "2-digit",
  //     month: "short",
  //     year: "numeric",
  //     hour: "numeric",
  //     minute: "2-digit",
  //     hour12: true,
  //   });
  // }
  const formatDateTime = (dateInput) => {
    if (!dateInput) return 'Not Available (N/A)';

    const date = new Date(dateInput);

    if (isNaN(date.getTime())) {
      return 'Not Available (N/A)';
    }

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours || 12;

    return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
  };

  return (
    <>
      <Box className={styles.modalOverlay} onClick={onClose}>
        <Box className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <Box className={styles.modalHeader}>
            <Typography className={styles.modalTitle}>Complaint Details</Typography>
            <Box className={styles.statusSection}>
              <Chip label={complaint.status} style={getStatusUnderReviewComplaintsColor(complaint.status)} className={styles.statusChip} />
              <IconButton onClick={onClose} className={styles.closeButton} size="small">
                <Close />
              </IconButton>
            </Box>
          </Box>
          {/* Complaint Overview */}
          <Box className={styles.studentOverview}>
            <Box className={styles.avatarSection}>
              <Box className={styles.studentInfo}>
                <Typography className={styles.studentEmail}>Complaint ID</Typography>
                <Typography className={styles.studentName}>{complaint.complaintId || 'Not Available (N/A)'}</Typography>
              </Box>
              <Box className={styles.studentInfo}>
                <Typography className={styles.studentEmail}>Complaint Date & Time</Typography>
                <Typography className={styles.studentName}>{formatDateTime(complaint?.createdAt)}</Typography>
              </Box>
            </Box>
          </Box>

          {/* Complaint Details Section */}

          {/* Location Details Section */}
          <Box className={styles.detailsSection}>
            <Typography className={styles.sectionTitle}>Complaint Details</Typography>
            <Box className={styles.detailsGrid}>
              <div className={styles.detailsNameGrid}>
                <Box className={styles.detailItem}>
                  <Typography className={styles.detailLabel}>Complaint By</Typography>
                  <Typography className={styles.detailValue}>{complaintByName}</Typography>
                </Box>
                <Box className={styles.detailItem}>
                  <Typography className={styles.detailLabel}>Mobile Number</Typography>
                  <Typography className={styles.detailValue}>{complaintByPhone}</Typography>
                </Box>
              </div>

              <div className={styles.detailsNameGrid}>
                <Box className={styles.detailDescription}>
                  <Typography className={styles.detailLabel}>Description:</Typography>
                  <Typography className={styles.detailValue}>{complaint.description || 'Not Available (N/A)'}</Typography>
                </Box>
                <Box className={styles.detailDescription}>
                  <Typography className={styles.detailLabel}>Categories:</Typography>
                  <Typography className={styles.detailValue}>{complaint?.category || 'Not Available (N/A)'}</Typography>
                </Box>
              </div>

              <div className={styles.detailsNameGrid}>
                <Box className={styles.detailItem}>
                  <Typography className={styles.detailLabel}>Department</Typography>
                  <Typography className={styles.detailValue}>{complaint?.department || 'Not Available (N/A)'}</Typography>
                </Box>
                {/* {complaint.status !== 'pending' && (
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>{handledByLabel}</Typography>
                    <Typography className={styles.detailValue}>{complaint?.actionByUser?.name || 'Not Available (N/A)'}</Typography>
                  </Box>
                )} */}
              </div>

              {/* <div className={styles.detailsNameGrid}>
                <Box className={styles.detailDescription}>
                  <Typography className={styles.detailLabel}>Description:</Typography>
                  <Typography className={styles.detailValue}>{complaint.description || 'Not Available (N/A)'}</Typography>
                </Box>
              </div> */}

              <div style={{ marginTop: 10 }} className={styles.detailsNameGrid}>
                <Box style={{ width: '100%', marginTop: '10px' }} className={styles.detailDescription}>
                  <Typography className={styles.detailLabel}>Attachments</Typography>
                  <div className={styles.attachmentContainer}>
                    {complaint.image ? (
                      Array.isArray(complaint.image) ? (
                        complaint.image.map((image, index) => {
                          const fileName = image.split('/').pop();
                          return (
                            <div key={index} className={styles.attachmentWrapper}>
                              <Typography className={styles.attachmentFileName}>{fileName}</Typography>
                              <a
                                href={`${image}`}
                                // target="_blank"
                                rel="noopener noreferrer"
                                className={styles.attachmentIcon}
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M15 3H21V9" stroke="#644EE5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M10 14L21 3" stroke="#644EE5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                  <path
                                    d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                                    stroke="#644EE5"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </a>
                            </div>
                          );
                        })
                      ) : (
                        <div className={styles.attachmentWrapper}>
                          <Typography className={styles.attachmentFileName}>{complaint.image.split('/').pop()}</Typography>
                          <a
                            href={`${complaint.image}`}
                            // target="_blank"
                            rel="noopener noreferrer"
                            className={styles.attachmentIcon}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M15 3H21V9" stroke="#644EE5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M10 14L21 3" stroke="#644EE5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path
                                d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                                stroke="#644EE5"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </div>
                      )
                    ) : (
                      <Typography className={styles.noAttachment}>No Attachment</Typography>
                    )}
                  </div>
                </Box>
              </div>
            </Box>
          </Box>

          {/* hold details */}
          {complaint?.history?.hold && complaint.history.hold.length > 0 && (
            <Box className={styles.detailsSection}>
              <Typography className={styles.sectionTitle}>Hold Details</Typography>
              <Box className={styles.detailsGrid}>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Hold By</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.hold[0]?.actionByName || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Hold Date & Time</Typography>
                    <Typography className={styles.detailValue}>
                      {formatDateTime(complaint?.history?.hold[0]?.timestamp) || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                </div>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>remark</Typography>
                    <Typography className={styles.detailValue}>{complaint?.history?.hold[0]?.remark || 'Not Available (N/A)'}</Typography>
                  </Box>
                </div>
              </Box>
            </Box>
          )}

          {complaint?.history?.forwarded && complaint.history.forwarded.length > 0 && (
            <Box className={styles.detailsSection}>
              <Typography className={styles.sectionTitle}>Forwarded Details</Typography>
              <Box className={styles.detailsGrid}>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Forwarded By</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.forwarded[0]?.actionByName || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Forwarded Date & Time</Typography>
                    <Typography className={styles.detailValue}>
                      {formatDateTime(complaint?.history?.forwarded[0]?.timestamp) || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                </div>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>From Category</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.forwarded[0]?.fromCategory || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>To Category</Typography>
                    <Typography className={styles.detailValue}>{complaint?.history?.forwarded[0]?.toCategory}</Typography>
                  </Box>
                </div>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>remark</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.forwarded[0]?.remark || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                </div>
              </Box>
            </Box>
          )}

          {/* Room Allocated Section */}
 
          {(complaint.status == 'rejected' ) && (
             <Box className={styles.detailsSection}>
              <Typography className={styles.sectionTitle}>Rejected Details</Typography>
              <Box className={styles.detailsGrid}>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Rejected By</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.rejected[0]?.actionByName || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Rejected Date & Time</Typography>
                    <Typography className={styles.detailValue}>
                      {formatDateTime(complaint?.history?.rejected[0]?.timestamp) || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                </div>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Remark</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.rejected[0]?.remark || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                
                </div>
       
              </Box>
            </Box>
          )}

          {(complaint.status == 'resolved' ) && (
             <Box className={styles.detailsSection}>
              <Typography className={styles.sectionTitle}>Resolved Details</Typography>
              <Box className={styles.detailsGrid}>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Resolved By</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.resolved[0]?.actionByName || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Resolved Date & Time</Typography>
                    <Typography className={styles.detailValue}>
                      {formatDateTime(complaint?.history?.resolved[0]?.timestamp) || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                </div>
                <div className={styles.detailsNameGrid}>
                  <Box className={styles.detailItem}>
                    <Typography className={styles.detailLabel}>Remark</Typography>
                    <Typography className={styles.detailValue}>
                      {complaint?.history?.resolved[0]?.remark || 'Not Available (N/A)'}
                    </Typography>
                  </Box>
                
                </div>
       
              </Box>
            </Box>
          )}

          {/* mark as under review for  */}
          {/* onclinking api call ot maeke this request under review */}
          {complaint.status == 'pending' && tabState === 'pendingComplaints' && complaintManagementPermission.approve && (
            <Box className={styles.actionsContainer}>
              <Button
                variant="contained"
                color="primary"
                className={styles.resolveButton}
                onClick={() => {
                  handleMarkAsReviewed(complaint);
                  setOtpVerificationOpen(true);
                }}
              >
                Mark as Reviewed
              </Button>
            </Box>
          )}

          {/* mark as resplved btn only for superMostAdmin*/}
          {complaint.status == 'Under Review' && tabState === 'underReviewComplaints' && complaintManagementPermission.approve && (
            <Box className={styles.actionsContainer}>
              <Button variant="contained" color="primary" className={styles.resolveButton} onClick={() => setResolveOtpOpen(true)}>
                Mark As Resolved
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      {/* Status Change Modal - Outside of ViewComplaint modal to prevent event bubbling */}
      <StatusChange
        open={statusChangeModalOpen}
        onClose={() => setStatusChangeModalOpen(false)}
        onConfirm={handleStatusChangeConfirm}
        complaint={complaint}
      />
      <MarkAsResolvedModal
        open={markAsResolvedModalOpen}
        complaint={complaint}
        onConfirm={handleResolveComplaint}
        onClose={() => setMarkAsResolvedModalOpen(false)}
      />
      <OtpVerificationModal
        open={otpVerificationOpen}
        complaint={complaint}
        initialStatus="resolved"
        onConfirm={() => setMarkAsResolvedModalOpen(true)}
        onClose={() => setOtpVerificationOpen(false)}
      />
      {/* <OtpVerificationModal
        open={resolveOtpOpen}
        complaint={complaint}
        initialStatus="resolved"
        onConfirm={() => {
          setResolveOtpOpen(false);
          markAsResolvedModalOpen(true)
          setTimeout(() => setMarkAsResolvedModalOpen(true), 0);
        }}
        onClose={() => setResolveOtpOpen(false)}
      /> */}
    </>
  );
};

export default ViewComplaint;
